module.exports = __webpack_public_path__ + "static/media/tim-gouw-tYpp-eIZH44-unsplash.1ababcfa.jpg";